export const publishInstitutesAndLoadRosters = async ({ institutes, publish, loadRoster, publishRoster, isCancelled }) => {
  publish(institutes);
  await Promise.all(institutes.map(async institute => {
    const members = await loadRoster(institute);
    if (!isCancelled()) publishRoster(institute.id, members);
  }));
};
